import React from "react";
import { Fade } from "react-awesome-reveal";
import * as emailjs from "@emailjs/browser";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { Form } from "elements/Form";
import Button from "elements/Button";

export const DiscussForm = (actions) => {
  const { data, resetForm } = actions;

  const submitEmail = () => {
    const { name, email, phone, message } = data;

    const templateParams = {
      from_name: `${name} - ( ${phone} - ${email} )`,
      to_name: "Our Company",
      message: message,
    };

    if (name !== "" && email !== "" && phone !== "" && message !== "") {
      emailjs
        .send(
          "service_h4gtndg",
          "template_a9tvs7a",
          templateParams,
          "user_csqIxzN5mKsl1yw4ffJzV"
        )
        .then(
          () => {
            toast.success("Success! We'll get back to you soon. Thank you!");
            resetForm();
          },
          (error) => {
            toast.error(error);
          }
        );
    } else {
      toast.error("Please fill out the blank form.");
    }
  };

  return (
    <section className="flex flex-col container mx-auto mt-10 justify-center">
      <Fade direction="down" triggerOnce>
        <h1 className="text-5xl text-green-600 text-center font-bold">
          Contact Us
        </h1>
      </Fade>

      <Fade direction="up" triggerOnce>
        <p className="font-light text-lg text-gray-500 text-center mb-12">
          {/* eslint-disable-next-line react/no-unescaped-entities */}
          Please fill out the form below to contact and we'll get back to you in
          less than 24 hours.
        </p>
      </Fade>

      <Fade direction="up" triggerOnce>
        <div className="flex flex-col">
          <div className="flex flex-col sm:flex-row mx-auto">
            <Form
              id="name"
              name="name"
              type="text"
              value={data.name}
              placeholder="Your name"
              className="border-2 border-green-500 rounded-lg p-3 text-green-600 focus:outline-none focus:ring-2 focus:ring-green-500"
              onChange={actions.onChange}
            />
          </div>

          <div className="flex flex-col sm:flex-row mx-auto">
            <Form
              id="email"
              name="email"
              type="email"
              value={data.email}
              placeholder="Your email address"
              className="border-2 border-green-500 rounded-lg p-3 text-green-600 focus:outline-none focus:ring-2 focus:ring-green-500"
              onChange={actions.onChange}
            />
            <Form
              id="phone"
              name="phone"
              type="number"
              value={data.phone}
              placeholder="Your contact number"
              className="border-2 border-green-500 rounded-lg p-3 text-green-600 focus:outline-none focus:ring-2 focus:ring-green-500"
              onChange={actions.onChange}
            />
          </div>

          <div className="mx-auto">
            <Form
              id="message"
              name="Message"
              type="textarea"
              value={data.Message}
              placeholder="Your Message"
              className="border-2 border-green-500 rounded-lg p-3 text-green-600 focus:outline-none focus:ring-2 focus:ring-green-500"
              onChange={actions.onChange}
            />
          </div>

          <Button
            className="text-xl mx-auto px-12 py-3 mt-5 bg-green-600 text-white rounded-full border-2 border-green-600 hover:bg-green-700 transition duration-200 focus:outline-none"
            type="button"
            onClick={submitEmail}
          >
            Submit
          </Button>
        </div>
      </Fade>

      <ToastContainer />
    </section>
  );
};
